import React from 'react';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';

type Props = {
    busy: boolean,
    sectionName: string,
    onRemove: () => void,
    onClose: () => void,
};

export const RemoveSectionModal = ({busy, sectionName, onRemove, onClose}: Props) => (
    <>
        <DialogHeader onClose={onClose}>
            Remove Section
        </DialogHeader>
        <DialogMain style={{padding: 24}}>
            Remove <b>{sectionName}</b> section?
        </DialogMain>
        <DialogFooter>
            <Group>
                <Button busy={busy} variant="Type.PRIMARY" onClick={onRemove}>
                    Remove section
                </Button>
                <Button variant="Type.SECONDARY" onClick={onClose}>
                    Cancel
                </Button>
            </Group>
        </DialogFooter>
    </>
);
